module.exports = __webpack_public_path__ + "static/media/metales.74744225.jpg";